module.exports = __webpack_public_path__ + "img/banner1.b8902203.png";